import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_CLIENT_ID, OKTA_ISSUER_URL } from './constants';

const oktaAuth = new OktaAuth({
  issuer: OKTA_ISSUER_URL,
  clientId: OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}/implicit/callback`,
  pkce: false,
  postLogoutRedirectUri: `${window.location.origin}/login`,
  transformAuthState: async (_oktaAuth, authState) => {
    return authState || { isAuthenticated: false };
  },
});

oktaAuth.start().then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <App oktaAuth={oktaAuth} />
    </React.StrictMode>,
    document.getElementById('root')
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
